 
import logo from '../img/logo.svg';
import '../css/App.css';
import { useDocumentTitle } from '../ts/useDocumentTitle';


function ErrorMissing() {
  useDocumentTitle('Page Not Found');

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <h1>Welcome to SideQuest</h1>
       <div/>
       <p> Error: The page you are looking for does not exist. </p>
      </header>
    </div>
  );
}

export default ErrorMissing;
